import StoreDetailsIcon from '../../../../images/icon-store-locator-details.svg';
import IconPlus from '../../../../images/icon-plus.svg';
import {
  getAddressFragment,
  getBrandFragment,
  getDistanceFragment,
  getStoreTypeFragment,
  getTitleFragment,
  getTopFragment
} from './fragments';

export const getListItemTemplate = (marker) => {
  const titleFragment = getTitleFragment(marker);
  const brandFragment = getBrandFragment(marker);
  const addressFragment = getAddressFragment(marker);
  const topFragment = getTopFragment(marker);
  const storeTypeFragment = getStoreTypeFragment(marker);
  const distanceFragment = getDistanceFragment(marker);

  return `
      <li class="results-item">
        <div class="row collapse">
          <div class="columns shrink">
            <img class="marker-icon" src="${StoreDetailsIcon}" alt="" width="35px" height="43px">
          </div>

          <div class="columns">
            <div class="row collapse align-middle margin-bottom-1">
              <div class="columns small-8">
                ${titleFragment}
              </div>
              <div class="columns small-4 text-right">
                ${topFragment}
              </div>
            </div>

            <div class="row collapse align-bottom margin-bottom-1">
              <div class="columns small-12 medium-8">
                ${brandFragment}
              </div>
              <div class="columns small-12 medium-4">
                ${storeTypeFragment}
              </div>
            </div>

            <div class="row collapse align-bottom">
              <div class="columns small-12 medium-8">
                ${addressFragment}
              </div>
              <div class="columns small-12 medium-2 text-right">
                ${distanceFragment}
              </div>
              <div class="columns small-12 medium-2 text-right">
                <button type="button" class="show-details-btn" data-show-details="${marker.info['@id']}">
                  <img src="${IconPlus}" alt="">
                </button>
              </div>
            </div>
          </div>
        </div>
      </li>
    `;
}
